import { render, staticRenderFns } from "./cover4.vue?vue&type=template&id=4a222da8&scoped=true&"
import script from "./cover4.vue?vue&type=script&lang=js&"
export * from "./cover4.vue?vue&type=script&lang=js&"
import style0 from "./cover4.vue?vue&type=style&index=0&id=4a222da8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a222da8",
  null
  
)

export default component.exports